import BaseConfiguratorService from '@configuratorware/configurator-frontendgui/App/Services/ConfiguratorService';
import { withGlobalLoader } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import {
  fetchConfigurationForDesignerProductPreview,
  fetchInitialConfiguration,
} from '../Reducers/Configurator/Actions';

export default class ConfiguratorService extends BaseConfiguratorService {
  loadConfigurationForDesignerProductPreview() {
    return Services.store.dispatch(withGlobalLoader(fetchConfigurationForDesignerProductPreview()));
  }

  loadInitialConfiguration() {
    return Services.store.dispatch(withGlobalLoader(fetchInitialConfiguration()));
  }
}
